<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Annual Stipend Report</h5>
  </div>
<div id="mainContent" class="container">
    <div class="modal-body">
      <div class="row">
        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label">Financial Year<span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <select class="form-control form-control-xs mt-1" [(ngModel)]="selectedFinancialYear" (change)="onYearselected()">
                <option value="">Select Year</option>
                <option *ngFor="let finance of financialYearList" [ngValue]="finance">
                  {{ finance.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label">Branch<span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <mat-form-field appearance="legacy" style="width: 100%">
                <mat-select multiple [(ngModel)]="selectedBranch" #designateBranch="ngModel">
                  <mat-option (click)="selectAllBranch(designateBranch, branchList)" [value]="0">Select All
                  </mat-option>
                  <mat-option #item (click)="onBranchSelected()" *ngFor="let branch of branchList" [value]="branch">
                    {{ branch.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
  
      <div class="row">
        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label"
              >Partner<span class="text-danger">*</span></label
            >
            <div class="col-sm-6">
              <!-- <select
                class="form-control form-control-xs mt-1"
                [(ngModel)]="selectedPartner"
                (change)="onPartnerSelected()"
              >
                <option value="">Select Partner</option>
                <option *ngFor="let partner of partnerList" [ngValue]="partner">
                  {{ partner.firstName }}{{ partner.lastName }}
                </option>
              </select> -->
              <mat-form-field appearance="legacy" style="width: 100%">
                <mat-select
                  multiple
                  [(ngModel)]="selectedPartner"
                  #designatePartner="ngModel"
                >
                  <mat-option
                    (click)="selectAllPartner(designatePartner, partnerList)"
                    [value]="0"
                    >Select All
                  </mat-option>
                  <mat-option
                    (click)="onPartnerSelected()"
                    #item
                    *ngFor="let partner of partnerList"
                    [value]="partner"
                  >
                    {{ partner.firstName }} {{ partner.middleName }}
                    {{ partner.lastName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            
          </div>
        </div>

        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label">Article Name<span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <mat-form-field appearance="legacy" style="width: 100%">
                <mat-select multiple [(ngModel)]="selectArticle" #designateArticleName="ngModel">
                  <mat-option (click)="selectAllArticleName(designateArticleName, articleNameList)" [value]="0">Select All
                  </mat-option>
                  <mat-option #item *ngFor="let article of articleNameList" [value]="article">
                    {{ article.firstName }} {{article.middleName}} {{article.lastName}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-sm-5 mt-2">
          <div class="row">
            <label class="col-sm-4 col-form-label"
              >From Closing Date<span class="text-danger">*</span></label
            >
            <div class="col-sm-6">
              <select
                class="form-control form-control-xs mt-1"
                [(ngModel)]="selectedFromClosing"
              >
                <option value="">Select From Date</option>
                <option
                  *ngFor="let closing of closingDateList"
                  [ngValue]="closing"
                >
                  {{ closing.closingDate }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-5 mt-2">
          <div class="row">
            <label class="col-sm-4 col-form-label"
              >To Closing Date<span class="text-danger">*</span></label
            >
            <div class="col-sm-6">
              <select
                class="form-control form-control-xs mt-1"
                [(ngModel)]="selectedToClosing"
              >
                <option value="">Select To Date</option>
                <option
                  *ngFor="let closing of closingDateList"
                  [ngValue]="closing"
                >
                  {{ closing.closingDate }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-2 mt-2">
          <button type="button" class="btn btn-sm btn-block btn-outline-theme" (click)="onViewReport()">
            View Report
          </button>
      </div>

        <div class="col-sm-2 mt-2" *ngIf="showExportToExcelButton">
          <button (click)="exportToExcelClick()" class="btn btn-sm btn-block btn-outline-theme">
            <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
          </button>
        </div>

        <div class="col-sm-2 mt-2" *ngIf="showExportToExcelButton">
          <button (click)="exportToPDFClick()" class="btn btn-sm btn-block btn-outline-theme">
            <i class="fa fa-file-pdf-o mr-2"></i>Export as PDF
          </button>
        </div>
      </div>
    </div>
  </div>

    <div class="container pt-3" id="mainContent" *ngIf="annualStipendReportList.length>0">

      <div class="row justify-content-center text-center">
        <span class="bg-theme-title"
          >P G BHAGWAT LLP, Chartered Accountants
        </span>
      </div>
      <div class="row justify-content-center text-center ">
        <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
      </div>

      <!-- <div class="row">
        <div class="col-sm-12" style="text-align: center">
          <span class="bg-theme-title">Financial Year</span>
        </div>
      </div> -->
      <!-- <div class="row">
        <div class="col-sm-12" style="text-align: center">
          <span class="bg-theme-title">Article Debit Credit</span>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-5">
          <label class="col-form-label"><b>Role: </b>Article</label>
        </div>
      </div> -->

      <div class="row col-md-12 mt-3">
        <table class="table table-bordered table-sm" style="display: block; overflow-x: auto; white-space: nowrap">
          <thead>
           <tr>
            <th>Article name</th>
            <th>Partner Name</th>
            <!-- <th>Month</th> -->
            <th>Amount of stipend</th>
            <th>Late diary submission penalty</th>
            <th>Late leave submission penalty</th>
            <th>Conveyance</th>
            <th>Scholarship</th>
            <th>Travel allowance</th>
            <th>Total</th>
           </tr>
          </thead>
          <tbody *ngFor="let data of annualStipendReportList">
                <tr>
                 <td>{{data.firstName}} {{data.middleName}} {{data.lastName}}</td>
                 <td>{{data.partnerName!=null?data.partnerName:'NA'}}</td>
                 <!-- <td>{{data.monthName}}</td> -->
                 <td>{{data.stipend}}</td>
                 <td>{{data.diaryPenalty}}</td>
                 <td>{{data.leavePenalty}}</td>
                 <td>{{data.conveyance}}</td>
                 <td>{{data.scholarship}}</td>
                 <td>{{data.travelAllowance}}</td>
                 <td>{{data.netStipend| number : '1.2-2'}}</td>
                </tr>
          </tbody>
          <tfoot style="background-color: #87cefa;">
            <tr>
              <td>Total</td>
              <!-- <td></td> -->
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>{{calculateAllTotal }}</td>
            </tr>
          </tfoot>
        </table>
        </div>
      </div>  
  </div>